<template>
  <div class="door-box" >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "doorBox",
  props: {
    height: {
      type: Number,
      default: 364,
    },
  },
};
</script>
<style lang="scss" scoped>
.door-box {
  position: relative;
  // overflow: hidden;
  width: 100%;
  height: 100%;
}
</style>